import { Component, OnInit } from '@angular/core';

@Component ({
  selector: 'app-home-control-cliente',
  templateUrl: './categoriasPT.component.html',
})

export class CategoriasPTComponent implements OnInit{

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/categoriasPT/categoriasPT.component.ts